<template>
  <div class="white-container" :key="$store.getters['resource/currentResource'].key" v-if="show">
    <invite-view
      @save="saveInvite"
      :params="this.$route.params"
    >
    </invite-view>

  </div>
</template>

<script>
  import InviteView from "./InviteView.vue";

  export default {
    components: {InviteView},
    name: 'InviteEditing',
    data: () => {
      return {
        show: false,
      }
    },

    created() {
      this.show = !!this.$route.params.id;
      if (!this.$route.params.id) {
        this.$router.push({path: '/invites'})
      }
    },
    computed: {
      id() {
        return this.$route.params.id
      }
    },
    methods: {
      saveInvite(params) {
        this.putData(`invites/${this.id}`, params, '/invites')
      }
    }
  }
</script>